import { FC, useState } from "react";
import { Popover, Tag, Checkbox, Space, Button, Tooltip } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { WLocation } from "@/types/inventoryV2";
import { getLocationIdx } from "@/utils/wLocation";

interface RefLocationsProps {
  refLocations: WLocation[];
  onChangeRefLocation: (locations: WLocation[]) => void;
  values?: string[];
}

const RefLocations: FC<RefLocationsProps> = ({
  refLocations,
  onChangeRefLocation,
  values = []
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) {
      // 打开时初始化 selectedIds
      setSelectedIds(values);
    }
    setOpen(isOpen);
  };

  if (!refLocations || refLocations.length === 0) {
    return null;
  }

  const handleCheckboxChange = (locationId: string, checked: boolean) => {
    if (checked) {
      setSelectedIds(prev => [...prev, locationId]);
    } else {
      setSelectedIds(prev => prev.filter(id => id !== locationId));
    }
  };

  const handleConfirm = () => {
    const selectedLocations = refLocations.filter(loc => selectedIds.includes(loc.id));
    onChangeRefLocation(selectedLocations);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const content = (
    <div style={{ width: 250 }}>
      <Space direction="vertical" style={{ width: '100%' }} size={8}>
        {refLocations.map((location) => (
          <Checkbox
            key={location.id}
            checked={selectedIds.includes(location.id)}
            onChange={(e) => handleCheckboxChange(location.id, e.target.checked)}
          >
            <Space>
              <Tag>{getLocationIdx(location)}</Tag>
              <Tag color="blue-inverse"> {location.count}</Tag>
            </Space>
          </Checkbox>
        ))}
      </Space>
      <div style={{ marginTop: 12, textAlign: 'right' }}>
        <Space size={8}>
          <Button size="small" onClick={handleCancel}>
            {t('common.cancel')}
          </Button>
          <Button size="small" type="primary" onClick={handleConfirm}>
            {t('common.confirm')}
          </Button>
        </Space>
      </div>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}
      content={content}
      title={t('warehouse.recommendedLocations')}
      trigger="click"
      placement="bottomLeft"
    >
      <Tag icon={<EnvironmentOutlined />} style={{ cursor: 'pointer' }} color="success" >
        {t('warehouse.recommendedLocations')}
      </Tag>
    </Popover>
  );
};

export default RefLocations;
